(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.setup', {
            parent: 'public',
            url: '/setup/:merchantId',
            data: {
                authorities: [],
                specialClass: " white-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.setup': {
                    templateUrl: 'app/public/setup/setup.html',
                    controller: 'SetupController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.cancel': {}
                //'footer@app': {
                //    templateUrl: 'app/layouts/footer/footer.html'
                //}

            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('public.setup');
                    //return $translate.refresh();
                }]
            }

        });
    }
})();
